module.exports = __webpack_public_path__ + "static/media/x-trail-hero.98a088b7.jpg";